import React, { Component } from "react"
import { GridProps, Table } from 'semantic-ui-react';
import styled from 'styled-components';

const StyleTableHeaderCell = styled(Table.HeaderCell)`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 10px !important;
`;

class HomeTableHeaderCell extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyleTableHeaderCell {...rest}>
          {children}
        </StyleTableHeaderCell>
    )
  }
}

export default HomeTableHeaderCell;
